export const DEFAULT_ICON_NAMES = Object.freeze([

    '#refresh',
    '#recalc',

    '#show',
    '#open',
    '#close',
    '#back',

    '#add',
    '#create',
    '#edit',
    '#edit-in-place',
    '#save',
    '#delete',
    '#delete-selected',
    '#filter',
    '#lock',
    '#unlock',
    '#preview',

    '#accept',
    '#confirm',
    '#cancel',

    '#insert',
    '#remove',
    '#clear',
    '#move-up',
    '#move-down',
    '#move-left',
    '#move-right',

    '#chevron-up',
    '#chevron-down',
    '#chevron-left',
    '#chevron-right',

    '#arrow-up',
    '#arrow-down',
    '#arrow-left',
    '#arrow-right',

    '#expand',
    '#collapse',

    '#toggle-on',
    '#toggle-off',

    '#checked',
    '#unchecked',

    '#upload',
    '#download',
    '#attachment',

    '#file',
    '#file-add',
    '#file-delete',
    '#file-edit',
    '#file-binary',
    '#file-text',
    '#file-image',
    '#file-audio',
    '#file-video',
    '#file-archive',
    '#file-code',
    '#file-csv',
    '#file-pdf',
    '#file-word',
    '#file-excel',
    '#file-powerpoint',

    '#folder',
    '#folder-outline',
    '#folder-open',
    '#folder-add',
    '#folder-up',

    '#home',
    '#next',
    '#prior',
    '#first',
    '#last',

    '#user',
    '#user-group',
    '#account',
    '#login',
    '#logout',

    '#play',
    '#stop',
    '#pause',
    '#backward',
    '#fast-backward',
    '#forward',
    '#fast-forward',

    '#search',

    '#sort',
    '#sort-up',
    '#sort-down',

    '#filter',
    '#no-filter',

    '#layout-table',
    '#layout-thumbnails',

    '#menu',
    '#options',
    '#options-vertical',
    '#settings',
    '#language',

    '#zoom-in',
    '#zoom-out',

    '#maximize',
    '#minimize',
    '#zoom-in',
    '#zoom-out',

    '#error',
    '#warning',
    '#info',
    '#question',

    '#pin',
    '#unpin',

    '#calendar',
    '#calendar-day',
    '#calendar-week',
    '#clock',

    '#spinner',

    '#chart',
    '#chart-line',
    '#chart-pie',
    '#chart-bar',
    '#chart-area',
    '#chart-scatter',

    '#table',



]);

export class IconRendererContract {

    renderIcon(name = null, options = null) {
        throw new Error(`${this.constructor.name}: renderIcon(name, options) is not implemented.`);
    }

}
